<template>
  <div class="box">
    <div class="boxTop">
      <div class="bx-content">
        <div class="head-box">
          <headerPage/>
        </div>
        <div class="banner">
          <div class="title-h4">中共北京市委社会工作部</div>
          <div class="title-img">
            <img src="@/assets/images/titleh1.png" alt="">
          </div>
          <div class="title-time">征集时间：本公告发布之日至2026年5月12日24:00</div>
          <div class="title-btn">
            <button @click="to('/formsub')">项目申报 <i class="iconfont icon-jiantou_xiangyou"></i></button>
          </div>
        </div>

        <div class="shuoming">
          <div class="shuoming-content">
<!--            <div class="shuoming-title">填表说明</div>-->
            <div class="shuoming-tex">
              为推动党建引领社会组织全生命周期管理服务，引导社会组织积极发挥作用，参与解决社会问题，提高社会服务能力，市委社会工作部现面向全市社会组织征集2026年服务社会项目。
            </div>
          </div>
        </div>

        <div class="box-center">
          <div class="box-title">
            一、项目方向
          </div>
          <div class="tex">
            以满足社会需求、解决社会问题为重点，面向全市征集下列10个方向的项目，择优进行支持。
          </div>
          <div class="list margin-top">
            <p class="two">社会群体关爱帮扶项目</p>
            <p class="two">城乡社区公共服务补充项目</p>
            <p class="two">暑假中小学生托管项目</p>
            <p class="two">社会心理服务项目</p>
            <p class="two">乡村振兴和花园城市建设项目</p>
            <p class="two">城乡社区居民关系融合项目</p>
            <p class="two">社会矛盾专业化调解项目</p>
            <p class="two">社会组织培育发展项目</p>
            <p class="two">京津冀协同发展项目</p>
            <p class="two">基层共建共治模式创新项目</p>
          </div>
        </div>

        <div class="box-center">
          <div class="box-title">
            二、申报主体要求
          </div>
          <div class="tex">（一）依法在市、区民政部门登记成立的社会团体、社会服务机构、基金会，具有独立承担民事责任的能力。街道社会组织联合会可组织有服务能力的备案社区社会组织联合申报项目。</div>
          <div class="tex">（二）治理结构健全，内部管理和监督制度完善。</div>
          <div class="tex">（三）具有独立、健全的财务管理、会计核算和资产管理制度。</div>
          <div class="tex">（四）具备提供服务所必需的设施、人员和专业技术能力。</div>
          <div class="tex">（五）具有依法缴纳税收和社会保障资金的良好记录。</div>
          <div class="tex">（六）2023年以来无违法记录，没有受到行政处罚，通过年检或按要求履行年度报告公示义务，信用状况良好，未被列入严重违法失信名单。</div>
          <div class="tex">（七）符合法律、法规规定的其他条件。</div>
        </div>

        <div class="box-center">
          <div class="box-title">
            三、征集时间
          </div>
          <div class="tex">本公告发布之日至2026年5月12日24:00</div>
        </div>

        <div class="box-center">
          <div class="box-title">
            四、项目要求
          </div>
          <div class="tex">（一）项目目的明确。针对的社会需求和社会问题具体，服务对象明确，有具体的实施地域。申报时一般应征得项目实施地社区（村）、街道（乡镇）或市、区有关部门的认可。</div>
          <div class="tex">（二）服务内容务实。有科学合理的服务举措和推进方法，专业性、可操作性强。</div>
          <div class="tex">（三）组织管理规范。有完善的管理制度，执行团队核心成员一般不少于3人、相对稳定且有一定专业性。</div>
          <div class="tex">（四）绩效目标具体。有具体明确的项目绩效目标和可量化指标。</div>
          <div class="tex">（五）预算编制科学。财政资金对单个项目的资助额度为3万—15万元，自筹资金额度无要求。预算应严格按照《民间非营利组织会计制度》和相关规定编制，要细化科目和测算依据。相关要求参照《2026年社会组织服务社会示范项目预算测算参考标准》。已通过其他途径由公共财政支持的项目，不得申报。</div>
          <div class="tex">（六）材料真实有效。项目申报单位必须保证项目申报材料的真实性和严肃性。</div>
          <div class="tex">单一社会组织本年度申报项目一般不多于2个。</div>
        </div>
        <div class="box-center">
          <div class="box-title">
            五、申报及评审流程
          </div>
          <div class="tex-list">
            <p>（一）项目申报单位4月30日至5月12日期间登录“社会组织众扶平台”（登录链接：http://shzzpt.org.cn），注册（去年已注册过账户的社会组织可直接使用原账户进行登录）并按要求填写报送项目申报书。可同步提供证明承接项目能力的相关材料。</p>
            <p>（二）市委社会工作部组织专家开展评审，按规定决定具体支持项目及资助金额，并通过“北京社会工作”微信公众号向社会公示拟立项项目。</p>
          </div>
        </div>
        <div class="box-center">
          <div class="box-title">
            六、咨询电话
          </div>
          <div class="tex-list">
            <p>（一）项目申报咨询：55560278、55560224、15201481025。</p>
            <p>（二）系统技术支持：13581851296、400-999-6541。</p>
          </div>
<!--          <div class="item-list">-->
<!--            <div class="item">-->
<!--              <div class="item-icon">-->
<!--                <i class="iconfont icon-phoneLoudspeaker"></i>-->
<!--              </div>-->
<!--              <b>（010）55560278、55560224</b>-->
<!--              <p>市委社会工作部三处</p>-->
<!--            </div>-->
<!--            <div class="item">-->
<!--              <div class="item-icon">-->
<!--                <i class="iconfont icon-shouji"></i>-->
<!--              </div>-->
<!--              <b>18519055478</b>-->
<!--              <p>系统填报 程凯</p>-->
<!--            </div>-->
<!--            <div class="item">-->
<!--              <div class="item-icon">-->
<!--                <i class="iconfont icon-youxiang5"></i>-->
<!--              </div>-->
<!--              <b>shbsanchu@163.com</b>-->
<!--              <p>工作邮箱</p>-->
<!--            </div>-->
<!--            <div class="item">-->
<!--              <div class="item-icon">-->
<!--                <i class="iconfont icon-dizhi"></i>-->
<!--              </div>-->
<!--              <b>北京市通州区运河东大街56号院市委社会工作部三处</b>-->
<!--              <p>通讯地址</p>-->
<!--            </div>-->
<!--          </div>-->
        </div>


        <div class="btnbox">
          <router-link to="/formsub" class="btn">项目填报</router-link>
        </div>
      </div>
    </div>
    <footerPage/>
  </div>
</template>
<script>
import headerPage from './common/headerPage'
import footerPage from './common/footerPage'
export default {
  name: "",
  data() {
    return {
      id:'',
    }
  },
  computed: {

  },
  components: {
    headerPage,
    footerPage,
  },
  created() {

  },
  methods: {
    // 跳转
    to(path) {
      this.$router.push(path)
    },
  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  background: url('../../assets/images/banner_01.png') no-repeat top center;
  background-size: auto 620px;
  .boxTop {
    width: 100%;

    .shuoming {
      width: 100%;
      padding: 10px;
      background: #e9effa url('../../assets/images/line.png') no-repeat top center;
      background-size: auto 10px;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);

      .shuoming-content {
        width: 100%;
        padding: 30px;
        background: #ffffff;

        .shuoming-tex {
          width: 100%;
          font-size: 18px;
          letter-spacing: 1px;
          color: #333333;
          line-height: 32px;
          margin-bottom: 10px;
          text-indent: 32px;
        }

        .shuoming-title {
          width: 100%;
          font-size: 20px;
          letter-spacing: 1px;
          color: #1546c5;
          font-weight: bold;
          margin-bottom: 20px;
        }
      }
    }

    .head-box {
      width: 100%;
    }

    .banner {
      width: 100%;
      padding: 60px 0;

      .title-btn {
        width: 100%;
        padding-top: 35px;

        button {
          display: block;
          width: 184px;
          height: 52px;
          background-color: #ffffff;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          letter-spacing: 2px;
          color: #1546c5;
          font-weight: bold;

          i {
            font-size: 18px;
            color: #1546c5;
            font-weight: bold;
            margin-left: 10px;
          }
        }
      }

      .title-time {
        width: 100%;
        font-size: 18px;
        letter-spacing: 2px;
        color: #f7e34d;
      }

      .title-img {
        width: 100%;
        padding: 50px 0;

        img {
          width: 674px;
          height: auto;
        }
      }

      .title-h4 {
        width: 100%;
        font-size: 24px;
        letter-spacing: 2px;
        color: #ffffff;
      }
    }
    .btnbox {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 30px;
      .btn {
        width: 266px;
        height: 70px;
        background-image: linear-gradient(90deg,
          #0115a6 0%,
          #1546c5 100%);
        border-radius: 20px;
        font-size: 20px;
        letter-spacing: 2px;
        color: #ffffff;
        font-weight: bold;
        text-align: center;
        line-height: 70px;
      }
    }
    .box-center {
      width: 100%;
      background-color: #ffffff;
      box-shadow: 0px 0px 20px 0px
      rgba(0, 0, 0, 0.03);
      padding: 30px;
      margin-top: 30px;

      .box-title {
        height: 52px;
        line-height: 50px;
        width: max-content;
        padding: 0 35px;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 2px;
        color: #ffffff;
        background: url('../../assets/images/title.png') no-repeat;
        background-size: 100% 100%;
        margin-bottom: 20px;
      }
      .tex {
        width: 100%;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 1px;
        color: #333333;
      }
      .tit {
        width: 100%;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 1px;
        color: #1546c5;
        border-left: 8px #1546c5 solid;
        padding-left: 10px;
        margin: 20px 0;
      }

      .list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        p {
          width: 275px;
          height: 70px;
          background-color: #f5f7fc;
          line-height: 70px;
          font-size: 16px;
          color: #333333;
          text-align: center;
          margin-bottom: 15px;
          &.one {
            width: 756px;
          }
          &.two {
            width: 560px;
          }
          &.three {
            width: 370px;
          }
          &.four {
            width: 364px;
          }
        }
      }
      .tex-list {

        width: calc(100% - 50px);
        border-left: 1px solid #ccd8f7;
        padding-left: 40px;
        margin-left: 50px;
        p {
          width: 100%;
          padding: 15px 0;
          font-size: 18px;
          letter-spacing: 1px;
          color: #333333;
          position: relative;

          &::before {
            content: '';
            width: 14px;
            height: 14px;
            background-color: #1546c5;
            border-radius: 7px;
            position: absolute;
            left: -48px;
            top: 20px;
          }
          &:after {
            content: '';
            width: 20px;
            height: 20px;
            border: solid 2px #1546c5;
            border-radius: 12px;
            position: absolute;
            left: -53px;
            top: 15px;
          }
        }
      }
      .item-list {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;

        .item {
          width: 25%;
          b {
            display: block;
            text-align: center;
            font-size: 18px;
            letter-spacing: 1px;
            color: #333333;
            font-weight: bold;
            width: 100%;
            text-align: center;
            margin-top: 25px;
            height: 40px;
          }
          p {
            width: 100%;
            text-align: center;
            font-size: 16px;
            letter-spacing: 1px;
            color: #333333;
            margin-top: 10px;
          }
          .item-icon {
            width: 104px;
            height: 104px;
            background-color: #f5f7fc;
            line-height: 104px;
            text-align: center;
            border-radius: 100%;
            margin: 0 auto;
            i {
              font-size: 40px;
              color: #1546c5;
            }
          }
        }
      }
    }
  }
}


</style>


